export class LoginInfo {
  Email: string;
  PasswordHidden: string;
  RememberMe: boolean;
  ReturnUrl: string;
  mode: string = 'ajax';
  ShowConfirmAccount: boolean;
  LastLoginProvider: string;
  ProfusionShowDealsPending: boolean;
}

export class AccountInfo {
  Email: string;
  PasswordHidden: string;
  ConfirmPasswordHidden: string;
  FirstName: string;
  LastNameField: string;
  RememberMe: boolean;
  ReturnUrl: string;
}

export class ForgotPasswordViewModel {
  Email: string;
  Title: string;
}

export class MagicLinkViewModel {
  Email: string;
  Title: string;
}

export class UserProfile {
  Email: string;
  UserName: string;
  FirstName: string;
  LastName: string;
  LastLogin: boolean;
  PhoneNumber: string;
}
export class SocialUserLoginInfo {
  LoginProvider: string;
  ProviderKey: string;
  ProviderDisplayName?: string;
  AuthToken: string;
  IdToken: string;
  FirstName: string;
  LastName: string;
  Name: string;
  Email: string;
  IsPersistent: boolean;
}

export class LoginResult {
  User: UserProfile;
  Success: boolean;
  Redirect: string;
  Errors: string[];
  Message: string;
}
